<template>
  <section id="services">
    <div class="container" style="margin-top:-15px">
      <div class="row">
        <div class="col-lg-12">
          <p>
            Whether residential, commercial, hybrid schemes or home owners associations – we offer a
            complete property management solution tailored for the needs of the individual community
            scheme.
          </p>
          <p>
            We are proud members of the National Association of Managing Agents and registered
            Estate Agents and Debt Collectors offering the following valuable functions to the
            residents and corporate bodies alike:
          </p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <h4
            style="cursor:pointer"
            @click="$vuetify.goTo('#contactFoot', { duration: 2000, easing: 'easeInOutCubic' })"
          >
            Contact us for a quote
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="section-header">
            <h2>Our Services</h2>
          </div>
          <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                id="takeOn-tab"
                data-toggle="tab"
                href="#takeOn"
                role="tab"
                aria-controls="takeOn"
                aria-selected="true"
                ><h5>Take-on Audit</h5>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="levy-tab"
                data-toggle="tab"
                href="#levy"
                role="tab"
                aria-controls="levy"
                aria-selected="false"
                ><h5>Levy, Billing and Collections</h5>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="financial-tab"
                data-toggle="tab"
                href="#financial"
                role="tab"
                aria-controls="financial"
                aria-selected="false"
                ><h5>Financial Management and Accounting</h5>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="advisory-tab"
                data-toggle="tab"
                href="#advisory"
                role="tab"
                aria-controls="advisory"
                aria-selected="false"
                ><h5>Advisory and Secretarial functions</h5>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="admin-tab"
                data-toggle="tab"
                href="#admin"
                role="tab"
                aria-controls="admin"
                aria-selected="false"
                ><h5>Administrative functions</h5>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div align="left" class="col-lg-12">
          <div class="tab-content">
            <div class="tab-pane active" id="takeOn" role="tabpanel" aria-labelledby="takeOn-tab">
              On appointment of company as managing agent, we perform a take-on audit which entails:
              <p></p>
              <p>
                • Deeds search to confirm that correct owners and their details are loaded for levy
                billing and communication purposes.
              </p>
              <p>• Validation of sectional tile plans, PQ and levy schedule.</p>
              <p>
                • Levy Budget review, identification of risks and formulation of recommendations.
              </p>
              <p>• Accounting quality assessment from last financial statements to date.</p>
              <p>
                • Confirmation that the adjusting journals and opening balance adjustments agree to
                the auditor’s report.
              </p>
              <p>• Assessment of 10 MAP Plan and CSOS compliance.</p>
              <p>• Assessment of insurance cover.</p>
              <p>• Assessment of firefighting equipment.</p>
              <p>• Confirmation of conduct rules lodged with CSOS.</p>
              <p>
                • Assessment of owner arrear levies, credit control procedures, and legal report.
              </p>
              <p>• Assessment of compliance to relevant legislation.</p>
              <p>• Compilation of a report and action log to address identified gaps</p>
              <p>
                • Compilation of a property management control schedule demonstrating required
                monthly operational activities to be managed.
              </p>
            </div>
            <div class="tab-pane" id="levy" role="tabpanel" aria-labelledby="levy-tab">
              <p>• Distribution of monthly levy statements to owners by email</p>
              <p>• Collection of monthly levies and charges due to CSOS</p>
              <p>• Credit Control of outstanding levies</p>
              <p>• Billing of interest on arrears</p>
              <p>• Soft Collections</p>
              <p>• Attorney Collections liaison</p>
              <p>• Liaison with metering companies</p>
              <p>• Issuing of levy clearance certificates</p>
            </div>
            <div class="tab-pane" id="financial" role="tabpanel" aria-labelledby="financial-tab">
              <p>
                • Payment of approved operational and capital expenditure as per the approved budget
                and on sign-off in accordance with scheme executive instructions.
              </p>
              <p>
                • To open and / or operate a bank account in the name of the community scheme or a
                trust account which include current, savings and investment accounts in the name of
                the Scheme.
              </p>
              <p>
                • To keep books of account and records in accordance with standard accounting
                principles.
              </p>
              <p>• Preparing the annual audit file for the appointed auditors.</p>
              <p>
                • Preparing the annual budget and levy schedule for approval by the members at the
                AGM.
              </p>
              <p>
                • To compile and distribute a monthly management report to scheme executives which
                will include an income and expenditure statement detailing actual expenses versus
                budgeted expenses, a balance sheet, a debtor and supplier age analysis and any such
                supplementary information as the scheme executives may require.
              </p>
              <p>• Invest surplus funds after payment of creditors.</p>
            </div>
            <div class="tab-pane" id="advisory" role="tabpanel" aria-labelledby="advisory-tab">
              <p>• Managing the owners’ register</p>
              <p>
                • Consulting and providing advice on risk, compliance and governance matters where
                required.
              </p>
              <p>
                • Preparation and distribution of notices of meetings, agendas and minutes in
                respect of executives and owners’ meetings
              </p>
              <p>
                • Attending limited scheme executive meetings and the annual Annual General Meeting.
              </p>
              <p>• Attending Special General Meetings on request.</p>
              <p>• Arrange property valuation in terms of PMR 23(3).</p>
              <p>• Arrange competitive comprehensive property and fidelity insurance cover.</p>
              <p>• Submission and management of all insurance claims.</p>
              <p>
                • Maintenance management for common property to arrange quotes, booking contractors
                and facilitating approval and payment.
              </p>
              <p>• Maintenance of statutory records.</p>
              <p>• Assisting with queries from management and owners.</p>
              <p>• Assisting executives with CSOS disputes.</p>
            </div>
            <div class="tab-pane" id="admin" role="tabpanel" aria-labelledby="admin-tab">
              <p>• Managing the owners’ register.</p>
              <p>• Safekeeping of the governance documents such as the conduct rules.</p>
              <p>• Issuing clearance and insurance certificates as and when required.</p>
              <p>• Performing general secretarial duties.</p>
              <p>
                • Recording, preparing and circulating the minutes of the trustee meetings and the
                AGM’s.
              </p>
              <p>• The preparing and circulation of all correspondence to owners and residents</p>
              <p>• Safekeeping of the minute books in perpetuity.</p>
              <p>
                • Provision of a legal address domicilium citandi et executandi for the body
                corporate.
              </p>
              <p>
                • Archiving and safekeeping of all body corporate records, as required by current
                legislation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nav-tabs li a {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom-color: rgb(221, 221, 221);
  height: 100%;
}

.nav-tabs li :hover {
  background-color: rgb(27, 117, 187);
}

.nav-tabs li a.active {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom-color: rgb(221, 221, 221);
}

.nav-tabs li a :hover {
  background-color: transparent;
  color: white;
}
</style>
